import { QueryFunctionContext } from "@tanstack/react-query";
import { Client } from "../client";
import { Controller } from "../controller";
import { AgentInteractions } from "../models";
import { dropRecentlyClosedInteractions } from "./recentlyClosedInteractions";

export const interactionsQueryKey = "interactions";
export const supervisorActiveInteractionKey = "supervisorActiveInteractions";

export {
	markInteractionRecentlyClosed,
	forgetRecentlyClosedInteraction,
} from "./recentlyClosedInteractions";

export const fetchInteractionsFn = async (_: QueryFunctionContext) => {
	const interactions = await Client.instance.get<AgentInteractions>(
		Controller.Interactions
	);

	return dropRecentlyClosedInteractions(interactions);
};
